import React from 'react';
import { Benefit } from '../@types/benefits';
import { useGetNotifications } from '../apiHooks/notifications.hook';
import { useGetProductsStatus } from '../apiHooks/productsStatus.hook';
import { useGetIs24SolvencyStatus, useGetSchufaStatus } from '../apiHooks/solvencyStatus.hook';
import {
  getBillcheckStatus,
  getCommonBenefitCardStatus,
  getDepositBenefitCardStatus,
  getInsuranceBenefitsStatus,
  getSolvencyBenefitCardStatus,
} from '../utils/getBenefitCardStatus.util';
import { useLegacyBillCheck } from './useLegacyBillCheck.hook';
import { useInsurancePackageStatus } from './useInsurancePackageStatus';
import { useAdacStatus } from './useAdacStatus';
import { useBillCheckV3 } from '@/components/content/benefits/modals/billCheckV3/hooks/useBillCheckV3.hook';

export const useGetBenefitCardsStatus = () => {
  const { productsStatus } = useGetProductsStatus();
  const { notifications } = useGetNotifications();
  const { schufaStatus, isSchufaStatusError } = useGetSchufaStatus();
  const { is24SolvencyStatus, isIs24SolvencyStatusError } = useGetIs24SolvencyStatus();
  const { lastBillCheck: lastLegacyBillCheck } = useLegacyBillCheck();
  const { lastBillCheck: lastV3BillCheck } = useBillCheckV3();
  const { isMietrechtsschutzEntitled } = useInsurancePackageStatus();
  const { isEntitled: isAdacEntitled, status: adacStatus, needsActivation: adacNeedsActivation } = useAdacStatus();

  const billCheckStatus = lastV3BillCheck?.billCheckStatus || lastLegacyBillCheck?.status;

  const benefitCardStatuses = React.useMemo(
    () => ({
      [Benefit.ADAC]: adacNeedsActivation
        ? { statusTextTranslationKey: 'benefitCardStatus.adac.activate', actionRequired: true }
        : getInsuranceBenefitsStatus(adacStatus, isAdacEntitled),
      [Benefit.KEY_EMERGENCY]: getCommonBenefitCardStatus(
        productsStatus?.profileBenefits?.keyEmergencyService === true,
      ),
      [Benefit.RENT_LEGAL]: getCommonBenefitCardStatus(productsStatus?.profileBenefits?.rentLegalAdvice === true),
      [Benefit.SCHUFA]: getSolvencyBenefitCardStatus(
        schufaStatus,
        is24SolvencyStatus,
        isSchufaStatusError,
        isIs24SolvencyStatusError,
      ),
      [Benefit.DEPOSIT]: getDepositBenefitCardStatus(productsStatus?.deposit, notifications),
      [Benefit.BILLCHECK]: getBillcheckStatus(billCheckStatus),
      [Benefit.RECHTSBERATUNG]: getInsuranceBenefitsStatus(productsStatus?.insurancePackage?.status),
      [Benefit.SCHLUESSELDIENST]: getInsuranceBenefitsStatus(productsStatus?.insurancePackage?.status),
      [Benefit.MIETRECHTSSCHUTZ]: getInsuranceBenefitsStatus(
        productsStatus?.insurancePackage?.status,
        isMietrechtsschutzEntitled,
      ),
      [Benefit.MEDIATION]: getInsuranceBenefitsStatus(productsStatus?.insurancePackage?.status),
    }),
    [
      adacNeedsActivation,
      adacStatus,
      isAdacEntitled,
      productsStatus,
      notifications,
      schufaStatus,
      isSchufaStatusError,
      is24SolvencyStatus,
      isIs24SolvencyStatusError,
      billCheckStatus,
      isMietrechtsschutzEntitled,
    ],
  );

  return benefitCardStatuses;
};
